import * as THREE from 'three'
const baseURL = 'https://resources.roche-bobois.com'
export const LoadConcreteMaterial = () => {
  const shapeMaterial = new THREE.MeshStandardMaterial({ color: 'rgb(150, 150, 150)' })
  // shapeMaterial.wireframe = true
  return shapeMaterial
}

export const LoadTrayMaterial = () => {
  const material = new THREE.MeshStandardMaterial()
  material.transparent = true
  material.metalness = 0.1
  material.roughness = 0.1
  material.color = new THREE.Color('rgb(230, 235, 235)')
  material.opacity = 0.35
  material.reflectivity = 0.5
  return material
}

export const LoadFooterMaterial = () => {
  const material = new THREE.MeshStandardMaterial()
  const text = new THREE.TextureLoader().load(
    `${baseURL}/corail/assets/SoilBeach0005_1_download600_2.jpg`
  )
  text.wrapS = THREE.RepeatWrapping
  text.wrapT = THREE.RepeatWrapping
  text.repeat.set(10, 10)
  material.map = text
  material.metalness = 1.0
  material.roughness = 0.3
  material.color = new THREE.Color('rgb(210, 210, 210)')
  material.reflectivity = 1
  return material
}
